import React from "react";
import { IconProps } from "./IconProps";

const PlusIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H10.625V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H9.375V3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125V9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.75 16C27.75 16.1989 27.671 16.3897 27.5303 16.5303C27.3897 16.671 27.1989 16.75 27 16.75H16.75V27C16.75 27.1989 16.671 27.3897 16.5303 27.5303C16.3897 27.671 16.1989 27.75 16 27.75C15.8011 27.75 15.6103 27.671 15.4697 27.5303C15.329 27.3897 15.25 27.1989 15.25 27V16.75H5C4.80109 16.75 4.61032 16.671 4.46967 16.5303C4.32902 16.3897 4.25 16.1989 4.25 16C4.25 15.8011 4.32902 15.6103 4.46967 15.4697C4.61032 15.329 4.80109 15.25 5 15.25H15.25V5C15.25 4.80109 15.329 4.61032 15.4697 4.46967C15.6103 4.32902 15.8011 4.25 16 4.25C16.1989 4.25 16.3897 4.32902 16.5303 4.46967C16.671 4.61032 16.75 4.80109 16.75 5V15.25H27C27.1989 15.25 27.3897 15.329 27.5303 15.4697C27.671 15.6103 27.75 15.8011 27.75 16Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default PlusIcon;
